import { paymentsSlice } from './slice';

/* Fully typed Action creators are automagically generated for each case reducer function */
export const {
  updatePaymentFrequency,
  updatePaymentMethod,
  updateCreditCardName,
  updateCreditCardNumberMasked,
  updateCreditCardType,
  updateCybersourceToken,
  updateCreditCardCVV,
  updateCreditCardExpiryDate,
  updateBankAccountName,
  updateBankAccountBsb,
  updateBankAccountNumber,
  updateIsCreditCardValid,
  addPaymentError,
  clearPaymentErrors,
  resetCreditCardForm,
  resetBankAccountForm,
  updatePaymentState,
  updatePaymentReference,
  updateTransactionDetail,
  updateTransientToken,
  updateIsPaymentInProgress,
} = paymentsSlice.actions;

export type { Payments } from './types';
export default paymentsSlice.reducer;
